import { Component, Input, OnInit } from '@angular/core';
import { ACL_WTAX_LINE_COLUMNS } from '@core';
import { SettingsService } from '@delon/theme';

@Component({
  selector: 'app-jv-tranx-summary',
  templateUrl: './jv-tranx-summary.component.html',
  styleUrls: ['./jv-tranx-summary.component.less'],
  standalone: false
})
export class JvTranxSummaryComponent implements OnInit {
  readonly aclWtaxLineColumns = ACL_WTAX_LINE_COLUMNS;

  country = 'MY';

  @Input() currency: string = '';

  @Input() totalDebit: number | null | undefined = 0;
  @Input() totalCredit: number | null | undefined = 0;
  @Input() totalTaxDebit: number | null | undefined = 0;
  @Input() totalTaxCredit: number | null | undefined = 0;
  @Input() totalWTaxDebit: number | null | undefined = 0;
  @Input() totalWTaxCredit: number | null | undefined = 0;
  @Input() isTaxInclusive: boolean | null= false;

  @Input() hideTotal = false;

  constructor(private settings: SettingsService) {
    this.country = this.settings.user['company']?.country;
  }

  ngOnInit(): void {
    return;
  }
}
